import {
  UpdateStorefrontInput,
  Operation,
} from '../../../__generated__/globalTypes'

import {
  Storefront,
  storefrontString,
} from '../../fragments/__generated__/Storefront'

import updateStorefrontRawString from '../UpdateStorefront.graphql'

const updateStorefrontString = [
  updateStorefrontRawString,
  storefrontString,
].join('\n\n')

export type UpdateStorefrontData = {
  updateStorefront: {
    storefront: Storefront
  }
}

export type UpdateStorefrontVariables = {
  storefront: UpdateStorefrontInput
}

export type UpdateStorefront = Operation<
  UpdateStorefrontData,
  UpdateStorefrontVariables
>

export const UpdateStorefront = ({
  storefront,
}: UpdateStorefrontVariables): UpdateStorefront => ({
  query: updateStorefrontString,
  variables: {
    storefront: UpdateStorefrontInput(storefront),
  },
})
